import { render, staticRenderFns } from "./ExchangeRateModal.vue?vue&type=template&id=72adab62"
import script from "./ExchangeRateModal.vue?vue&type=script&lang=js"
export * from "./ExchangeRateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports